export const Types = {
    SET_ROUTER_LINK: "SET_ROUTER_LINK",
    REMOVE_ROUTER_LINK: "REMOVE_ROUTER_LINK",
}